(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keetsa-video-cards"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('keetsa-video-facade')) {
      class KeetsaVideoFacade extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;

          // Preserve the original facade markup so a playing card can be
          // reset back to its thumbnail when another card starts.
          if (this._facadeHTML == null) this._facadeHTML = this.innerHTML;

          this.bindTrigger();
          this.wireThumbnailFallback();
        }

        // Swap the YouTube maxres poster to hqdefault if maxres 404s
        // (maxresdefault does not exist for every video).
        wireThumbnailFallback() {
          const img = this.querySelector('img[data-yt-fallback]');
          if (!img) return;
          const fallback = img.getAttribute('data-yt-fallback');
          if (!fallback) return;
          const swap = () => {
            if (img.getAttribute('src') !== fallback) img.setAttribute('src', fallback);
          };
          if (img.complete && img.naturalWidth === 0) {
            swap();
            return;
          }
          img.addEventListener('error', swap, { once: true });
        }

        disconnectedCallback() {
          this.unbindTrigger();
          this._initialized = false;
        }

        bindTrigger() {
          this.trigger = this.querySelector('.keetsa-video-cards__trigger');
          if (!this.trigger) return;
          this._onActivate = this.play.bind(this);
          this.trigger.addEventListener('click', this._onActivate);
        }

        unbindTrigger() {
          if (this.trigger && this._onActivate) {
            this.trigger.removeEventListener('click', this._onActivate);
          }
          this.trigger = null;
        }

        get isPlaying() {
          return this.classList.contains('keetsa-video-cards--playing');
        }

        // Tear down the player and restore the clickable thumbnail.
        reset() {
          if (!this.isPlaying) return;
          this.unbindTrigger();
          this.classList.remove('keetsa-video-cards--playing');
          if (this._facadeHTML != null) this.innerHTML = this._facadeHTML;
          this.bindTrigger();
          this.wireThumbnailFallback();
        }

        play() {
          const id = this.dataset.videoId || '';
          if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;

          // Only one video plays at a time — stop every other playing card.
          const others = document.querySelectorAll(
            'keetsa-video-facade.keetsa-video-cards--playing'
          );
          others.forEach((el) => {
            if (el !== this && typeof el.reset === 'function') el.reset();
          });

          const title = this.dataset.title || 'Video';
          const iframe = document.createElement('iframe');
          iframe.src =
            'https://www.youtube-nocookie.com/embed/' +
            encodeURIComponent(id) +
            '?autoplay=1&rel=0';
          iframe.title = title;
          iframe.loading = 'lazy';
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          );
          iframe.className = 'keetsa-video-cards__iframe';

          this.classList.add('keetsa-video-cards--playing');
          this.replaceChildren(iframe);
          iframe.focus();
        }
      }

      customElements.define('keetsa-video-facade', KeetsaVideoFacade);
    }
  
  } catch(e) { console.error(e); }
})();
})();
